import { styled } from "@mui/system"
import useMarkdown from "hooks/useMarkdown"
import React from "react"

interface MarkdownProps {
  allow?: string[]
  children?: string
  inline?: boolean
  className?: string
}

/**
  Renders markdown text as html.
  Be sure to provide some basic styling of the container.

  @example
  <Markdown allow={['emphasis', 'link']}>{question.text}</Markdown>

  @example
  <Markdown allow={['emphasis']} inline={false}>{question.text}</Markdown>
*/

const Markdown = (props: MarkdownProps) => {
  const { allow, inline = true, children, className } = props
  // @ts-ignore
  const html = useMarkdown(children, {
    allow: allow,
    inline: inline,
  })

  if (props.inline) {
    return <_Inline dangerouslySetInnerHTML={{ __html: html }} className={className}></_Inline>
  } else {
    return <_Block dangerouslySetInnerHTML={{ __html: html }} className={className}></_Block>
  }
}

export default Markdown

const _Inline = styled("span")({})
const _Block = styled("span")({})
